<app-loader></app-loader>
<div class="contenuti" [@routeAnimations]="prepareRoute(outlet)">
    <div class="bgk__outlet">
    </div>

    <div class="other" [ngStyle]="getStyleIframe()">
        <router-outlet #outlet="outlet"></router-outlet>
    </div>
</div>